import React from 'react'
import { FaFacebook, FaGithub} from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

const Icons = ({ darkMode }) => {

  return (
    <div>
        <div className={` socialIcons py-2 ${darkMode ? "bg-Dsocial" : "bg-social"}`}>
            <div className="d-flex flex-column align-items-center justify-content-center">
                <a href="https://github.com/a7medelgaml" target="_blank" rel="noreferrer">
                    <FaGithub className='my-2' size={30} />
                </a>
                <a href="https://www.facebook.com/AhmedD.ElGaml" target="_blank" rel="noreferrer">
                    <FaFacebook className='my-2' size={30} />
                </a>
                <a href="https://www.instagram.com/ahmedd.elgaml/" target="_blank" rel="noreferrer">
                    <FaInstagram className='my-2' size={30} />
                </a>
                <a href="https://wa.me/201021699255/" target="_blank" rel="noreferrer">
                    <FaWhatsapp  className='my-2' size={30} />
                </a>
            </div>
        </div>
    </div>
  )
}

export default Icons